import { render, staticRenderFns } from "./revert-gamespercourse.vue?vue&type=template&id=ae1ea750&scoped=true"
import script from "./revert-gamespercourse.vue?vue&type=script&lang=js"
export * from "./revert-gamespercourse.vue?vue&type=script&lang=js"
import style0 from "./revert-gamespercourse.vue?vue&type=style&index=0&id=ae1ea750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1ea750",
  null
  
)

export default component.exports